import React from 'react';

import { BarChart } from 'echarts/charts';

import { getColorSchema } from 'components/Echart/colorScheme';
import { EchartsCore } from 'components/Echart/use-echarts';

import { useIsShowed } from 'hooks/useIsShowed';

const ReactEcharts = EchartsCore([BarChart]);

interface IProps {
  dataBar: string[];
  seriesDataOne: number[];
  seriesDataTwo: number[];
  firstName: string;
  secondName: string;
  echartOptions?: Object;
}

export const EchartDoubleBar = ({
  dataBar,
  seriesDataOne,
  seriesDataTwo,
  firstName,
  secondName,
  echartOptions,
}: IProps) => {
  const [svgRef, isShow] = useIsShowed();

  const { gradients } = getColorSchema('primary');

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      ...echartOptions?.tooltip,
    },
    legend: {
      left: 0,
      top: 'top',
      backgroundColor: '#F2F2F2',
      padding: [10, 370, 10, 10],
      color: '#323232',
      fontWeight: 300,
      fontSize: 14,
      itemWidth: 10,
      itemHeight: 10,
      itemGap: 20,
      icon: 'circle',
      ...echartOptions?.legend,
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      top: '65px',
      containLabel: true,
      ...echartOptions?.grid,
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      interval: 10,
      axisLabel: {
        formatter: '{value}%',
      },
      ...echartOptions?.xAxis,
    },
    yAxis: {
      type: 'category',
      offset: 205,
      axisLabel: {
        color: '#323232',
        fontWeight: 300,
        fontSize: 14,
        align: 'left',
        lineHeight: 22,
        ...echartOptions?.yAxis?.axisLabel,
      },
      data: dataBar,
      ...echartOptions?.yAxis,
    },
    series: [
      {
        name: firstName,
        type: 'bar',
        data: seriesDataOne,
        barGap: '80%',
        barWidth: '16%',
        itemStyle: {
          borderRadius: 5,
          color: gradients[0],
          ...echartOptions?.series?.[0].itemStyle,
        },
        cursor: echartOptions?.series?.[0].cursor,
      },
      {
        name: secondName,
        type: 'bar',
        data: seriesDataTwo,
        barWidth: '16%',
        itemStyle: {
          borderRadius: 5,
          color: '#082EB5',
          ...echartOptions?.series?.[1].itemStyle,
        },
        cursor: echartOptions?.series?.[1].cursor,
      },
    ],
  };

  return (
    <div ref={svgRef} className="desktop-tablet-only">
      {isShow ? (
        <ReactEcharts
          lazyUpdate
          opts={{ renderer: 'svg' }}
          option={option}
          style={{ width: '800px', height: '680px', maxWidth: '100%' }}
          theme="itransition"
        />
      ) : (
        <div style={{ width: '800px', height: '680px', maxWidth: '100%' }} className="skeleton-animation" />
      )}
    </div>
  );
};
